<!-- 
  Displays bar at top of application form with the "Back" button
-->
<template>
  <nav class="ApplicationNavBar" aria-label="breadcrumb">
    <div class="back float-left">
      <router-link to="/" tag="button" class="unstyled" :disabled="isEditing">
        <v-icon>arrow_back</v-icon>
      </router-link>
    </div>
    <div
      class="download-btn float-right"
      v-if="
        isDownloadAvailable &&
        application &&
        application.applicationId
      "
    >
      <DownloadDocument
        :school-code="application.schoolCode"
        :application-type="state.applicationType"
      />
    </div>
    <div class="print float-right" >
      <router-link
        :to="'/print/' + application.applicationId"
        tag="button"
        class="unstyled"
        :disabled="isEditing"
      >
        <font-awesome-icon focusable="false" class="icon" icon="print" />
        <span>Print</span>
      </router-link>
    </div>
  </nav>
</template>

<script>
import DownloadDocument from '@/components/application/DownloadDocument.vue'
import ModifiedByInfo from '@/components/application/ModifiedByInfo.vue'
import fieldHelperMixin from '@/helpers/fieldHelperMixin'

export default {
  name: 'ApplicationNavBar',
  components: {
    DownloadDocument,
    ModifiedByInfo
  },
  mixins: [fieldHelperMixin],
  computed: {
    state() {
      return this.$store.state
    },
    application() {
      return this.state.application.application || {}
    },
    isDownloadAvailable() {
      return true
    },

  },
  methods: {
    isLastUpdatedByParentEmail(val) {
      return val && val.indexOf('@') !== -1
    },
  }
}
</script>

<style scoped lang="scss">
.ApplicationNavBar {
  padding: 1.5rem 3rem 2.5rem 3rem;
  .icon {
    font-size: 1.5em;
    vertical-align: middle;
    margin-right: 0.5em;
  }
  .back,
  .print,
  .download-btn {
    display: inline-block;
    white-space: nowrap;
    span {
      vertical-align: middle;
    }
  }
  .print,
  .download-btn {
    text-align: right;
  }
}
</style>
